import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

/**
 * data = [{ name, sold, price, ... }]
 */
const TopSellingChart = ({ data = [], loading }) => {
  const chartData = (data || []).map((m) => ({
    name: m.name,
    sold: m.sold ?? 0,
  }));

  if (loading) return <p>Loading...</p>;
  if (!chartData.length) return <p>No top selling data</p>;

  return (
    <div style={{ width: "100%", height: 260 }}>
      <ResponsiveContainer>
        <BarChart data={chartData}>
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="sold" fill="#198754" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopSellingChart;
